import React, { useState, useEffect } from "react";
import ProgressFormReadOnly from "./re_registration_sub_read_only/ProgressFormReadOnly";
import RedoSubjectReadOnly from "./re_registration_sub_read_only/RedoSubjectReadOnly";
// import ReWriteExamReadOnly from "./re_registration_sub_read_only/ReWriteExamReadOnly";
import { useFormik
} from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { submitReRegistrationService } from "../../../services/ReRegistrationService";
import DigitalSignatureComponent from "../../common/DigitalSignatureComponent";
import StudentTypeButton from "../components/StudentTypeButton";
import { getFoundationOptions } from "../../../utils/CommonGroupingItem";
import { useParams } from "react-router-dom";


const student_type_options = [
  {id: 0, label: "Re-registering for failed modules", iconClassName: 'fa-light fa-repeat-1' },
  {id: 1, label: "Articulating into a new qualification", iconClassName: 'fa-light fa-sparkles' },
  // {id: 2, label: "Re-Registering for Nated Engineering (N3-N6)"},
]
function SchoolOfEngineering(props) {
  const {
    reRegSubject,
    registration,
    subjectProgressReadOnly,
    subjectReWriteReadOnly,
    subjectReDoReadOnly,
    subjectReSubReadOnly,
    foundation,
    student_type,
    readOnlyData
  } = props;
  const nated = registration?.nated;
  
  const { regid } = useParams()
  
  const [parentSubjectProgLength, setparentSubjectProgLength] = useState([
    { subject: "" },
  ]);
  const [parentSubjectRedoLength, setParentSubjectRedoLength] = useState([
    { subject: "" },
  ]);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);
  const [foundationOptions, setFoundationOptions] = useState([]);
  
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subjectProgress_: !foundation ? subjectProgressReadOnly : [{ subject: "" }],
      subjectRedo_: subjectReDoReadOnly,
      subjectReWrite_: subjectReWriteReadOnly,
      rereg_academy: props.registration.academy,
      rereg_id: props.registration.id,
      term_condn: checked,
      student_type: student_type,
    },
    validationSchema: Yup.object({     
    }),
    onSubmit: (values) => {
    },
  });

  useEffect(() => {
    if(regid){
      getFoundationOptions(regid, setFoundationOptions);
    }
  }, [regid]);
  
  return (
    <>
    <form onSubmit={formik.handleSubmit}>
    <div className="card-body disabled">
    <div className="theme-form application-form">            
    <div className="row">      
    
    
      <StudentTypeButton 
      disabled={true}
      formik={formik}
      labelReReg={nated ? "Register for next intake" : null}
      />
      {(Number(formik.values.student_type)  === 0 || Number(formik.values.student_type)  === 2) && (
        <>      
        <div className="form-group col-sm-12 inputfield">        
        <h5 className="textdanger heading-5">Re-registering for Failed Modules:</h5>
        <label>
Please select the subjects you wish to re-register for. These are subjects you did not pass or would like to attempt again. If you do not wish to repeat any subjects, simply leave this section blank.<br/><br/>
        </label>
        <RedoSubjectReadOnly
        formik={formik}
        setParentSubjectRedoLength={setParentSubjectRedoLength}
        parentSubjectRedoLength={parentSubjectRedoLength}
        reRegSubject={reRegSubject}
        />
        </div>  
        {nated  === 1 && (
              <>
              <div className="form-group col-sm-12 inputfield">
              <h5 className="textdanger heading-5">Subjects you are Progressing from:</h5>
              <label>
              Please select the subjects you have successfully completed at a DHET exam level and would like to progress from. If you do not wish to progress with any subjects, leave this section blank.
              </label>
              
              <ProgressFormReadOnly
                  formik={formik}
                  setparentSubjectProgLength={setparentSubjectProgLength}
                  parentSubjectProgLength={parentSubjectProgLength}
                  reRegSubject={reRegSubject}
                  />
              </div>
              </>)}  
        </>)}
        {/* <div className="form-group col-sm-12">
          <hr />
          </div>         */}
          
          {Number(formik.values.student_type)  === 1 && foundationOptions?.length > 0 && (
            <>
            {/* <div className='re-registration-bx-info-top form-group col-sm-12 inputfield'><h3>Foundation Progression:</h3></div> */}
            <div className="form-group col-sm-12 inputfield">
            <h5 className="textdanger heading-5"> Programme Articulation:</h5>
            <p>If you have successfully completed your current qualification, please indicate the programme you wish to articulate into for your next level of study.</p>
            {/* <ul>
            <li>Batchelors in Engineering Technology (BET): Foundation Mathematics and Engineering Science ≥ 60%</li>
            <li>Diploma in Engineering: Foundation Mathematics and Engineering Science ≥ 50%</li>
            <li>Higher Certificate in Engineering: Foundation Mathematics and Engineering Science ≥ 45%</li>
            </ul> */}
            { (foundation && subjectProgressReadOnly?.[0]?.subject) ? 
              <>
              <div className="row" key ={"progress1"}>
              <div key={"progress1"} className="col-sm-6">
              <select
              className="form-control"
              value={subjectProgressReadOnly?.[0]?.subject}
              disabled={true}
              >
              {(() => {
                const id = String(subjectProgressReadOnly?.[0]?.subject);
                const match = foundation && foundationOptions.find(o => id !== "0" && id === String(o.value));
                return match
                ? <option key={match.value} value={match.value}>{match.label}</option>
                : <option value="">---</option>;
              })()}     
              </select>
              </div>
              </div>
              </>
              :(
                <>
                <div className="row">
                <div className="col-sm-6">
                <select className="form-control" disabled>
                <option value="">---</option>
                </select>
                </div>
                </div>
                </>
              )}
              </div>
              </>)}

                
                
                  <div className="form-group col-sm-12 inputfield">
                  <DigitalSignatureComponent readOnly={true} readOnlyData={readOnlyData}/>
                  </div>
                  <div className="col-12 form-group inputfield">
                  <div className="custom-control custom-checkbox text-left box-tm">
                  <input
                  className={
                    "custom-control-input " +
                    (formik.touched.term_condn && formik.errors.term_condn
                      ? " is-invalid"
                      : "")
                    }
                    type="checkbox"
                    name="term_condn"
                    onChange={(e) => handleCheck(e)}
                    onBlur={formik.handleBlur}
                    checked={checked}
                    id="customCheck1"
                    disabled="disabled"
                    />
                    
                    <label
                    className="custom-control-label textdanger"
                    htmlFor="customCheck1"
                    >
                    I hereby confirm that I have read, understood and accepted
                    all <a href={registration?.linkTandC} target="_blank">Terms and Conditions</a> as set out in the application form that the above subject selections are correct, and understand
                    that there may be changes made based on the academic outcome.
                    </label>
                    {formik.touched.term_condn && formik.errors.term_condn ? (
                      <div className="invalid-feedback">
                      {formik.errors.term_condn}
                      </div>
                    ) : null}
                    </div>
                    </div>
                    </div>
                    </div>
                    <div className="Fmfooter">
                    <button
                    title="Submitted"
                    type="submit"
                    className="btn btn-submit btn-main btn-primary"
                    disabled="disabled"
                    >
                    {loading && <i className="fas fa-cog fa-spin"></i>} Submitted
                    </button>
                    {/* <button
                      className="btn btn-submit btn-main btn-danger ml-2"
                      disabled="disabled"
                      >
                      Cancel
                      </button> */}
                      </div>
                      </div>
                      </form>
                      </>
                    );
                  }
                  export default SchoolOfEngineering;
                  